module.exports = __webpack_public_path__ + "static/img/slider-44.3a797da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-44.jpg
// module id = ZoDz
// module chunks = 0